import axios from "axios";
import { message } from "antd";
const http = "https://cloud.mfgold.com.cn";
const http2 = "https://dtcenter.zjgl999.com";
const http3 = "https://credit.mfzb9999.com";
// axios.create({
//   baseURL: "https://cloud.mfgold.com.cn",
//   timeout: 5000,
// });
export const request = (url, method, params, responseType, signal) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: http + url,
      data: params,
      responseType,
      signal,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        message.error("服务器异常！");
        reject(err);
      });
  });
};
export const request2 = (url, method, params, responseType) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: http2 + url,
      data: params,
      responseType,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        message.error("服务器异常！");
        reject(err);
      });
  });
};
export const request3 = (url, method, params, responseType) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: http3 + url,
      data: params,
      responseType,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        message.error("服务器异常！");
        reject(err);
      });
  });
};

//设置请求超时
//设置请求拦截  有时后台会根据客户端来返回数据设置H5是告诉后台是使用电脑浏览器H5打开的
axios.interceptors.request.use((config) => {
  // console.log(config, "config");
  const token = "Bearer " + localStorage.getItem("token");
  config.headers = {
    "Content-Type": "application/x-www-form-urlencoded;",
    // 'Content-Type':'multipart/form-data;boundary=----WebKitFormBoundaryk4ZvuPo6pkphe7Pl',
    Authorization: token,
  };
  return config;
});

// HTTPresponse拦截
axios.interceptors.response.use(
  (res) => {
    // console.log("res", res);
    const status = Number(res.status) || 200;
    const messages = res.data.msg;
    const loginPath = sessionStorage.getItem("loginPath");
    // 后台定义 410 针对令牌过去的特殊响应码
    if (status === 410) {
      //   ElMessageBox.confirm("令牌状态已过期，请点击重新登录", "系统提示", {
      //     confirmButtonText: "重新登录",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       window.location.href = loginPath;
      //     })
      //     .catch(() => {});
      return;
    }
    // // 处理 500 网络异常
    if (status === 500) {
      message.error("服务器异常！");
    }
    if (status !== 200) {
      //   ElMessage({
      //     message: res,
      //     type: "error",
      //   });
      // return Promise.reject(new Error(message));
      message.error(res);
    } else {
      // router.push('/login')
      if (res.data.code <= 0) {
        message.warning(messages);
      } else if (
        messages === "获取成功" ||
        messages === "操作成功" ||
        messages === "success"
      ) {
      } else {
        message.success(messages);
      }
    }

    return res;
  },
  (error) => {
    console.info(error, "error");
    // 处理 503 网络异常
    // if (error.response.status === 503) {
    //   //   ElMessage({
    //   //     message: error.response.data.msg,
    //   //     type: "error",
    //   //   });
    //   message.error(error.response.data.msg);
    // } else {
    // }
    if (error.code !== "ERR_CANCELED") {
      message.error(error.message);
    }
    // NProgress.done();
    // return Promise.reject(new Error(error));
  },
);
